import { castDraft } from 'immer';
import React, { createContext, PropsWithChildren, useMemo, useReducer } from 'react';
import { DispatchState } from 'shared/hooks/useDispatchState';
import { ElectronicBillingDispatchObject } from '../store/actions';
import { electronicBillingContextReducer, ElectronicBillingState, initialState } from '../store/reducir';

export type ElectronicBillingDispatch<T = any> = React.Dispatch<ElectronicBillingDispatchObject<T>>;

export type ElectronicBillingContextType = DispatchState<ElectronicBillingState, ElectronicBillingDispatch>;

export const ElectronicBillingContext = createContext({} as ElectronicBillingContextType);

type ElectronicBillingProviderProps = PropsWithChildren<{
  extraState?: Partial<ElectronicBillingState>;
  testDispatch?: ElectronicBillingDispatch;
}>;

export const ElectronicBillingProvider: React.FC<ElectronicBillingProviderProps> = ({
  children,
  extraState = {},
  testDispatch,
}: ElectronicBillingProviderProps) => {
  const [state, dispatch] = useReducer(electronicBillingContextReducer, { ...initialState, ...extraState });

  const value = useMemo(() => {
    return { dispatch: testDispatch || dispatch, state: castDraft(state) };
  }, [dispatch, state]);

  return <ElectronicBillingContext.Provider value={value}>{children}</ElectronicBillingContext.Provider>;
};
